import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Link } from "react-router-dom";
import { Clock, ArrowRight } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then(r => setPosts(r.data)).catch(()=>{}); }, []);

  return (
    <div className="min-h-screen">
      <Navbar/>
      <section className="max-w-6xl mx-auto px-6 lg:px-8 py-20">
        <div className="text-xs uppercase tracking-[0.3em] gold-text mb-4">Journal</div>
        <h1 className="font-serif text-5xl md:text-6xl tracking-tighter-x brand-navy mb-6">Insights & essays</h1>
        <p className="text-xl text-slate-600 max-w-3xl">Thoughts from our tutors on exam technique, the Foundation-vs-Higher decision, and the role of AI in modern maths education.</p>
      </section>

      <section className="max-w-6xl mx-auto px-6 lg:px-8 pb-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map(p => (
            <Link key={p.id} to={`/blog/${p.slug}`} className="lift-card rounded-xl overflow-hidden border border-slate-200 bg-white block" data-testid={`blog-card-${p.slug}`}>
              {p.hero_image && <div className="h-48 overflow-hidden"><img src={p.hero_image} alt={p.title} className="w-full h-full object-cover"/></div>}
              <div className="p-6">
                <div className="flex items-center gap-3 text-xs text-slate-500 mb-3">
                  <span className="uppercase tracking-widest gold-text">{p.category}</span>
                  <span>·</span>
                  <span className="inline-flex items-center gap-1"><Clock size={12}/>{p.read_time} min</span>
                </div>
                <h3 className="font-serif text-xl brand-navy leading-snug mb-3">{p.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{p.excerpt}</p>
                <div className="mt-5 text-xs brand-navy font-medium inline-flex items-center gap-1.5">Read essay <ArrowRight size={14}/></div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <Footer/>
    </div>
  );
}
